import { render, staticRenderFns } from "./ReportProposition.vue?vue&type=template&id=15b7b903&scoped=true"
import script from "../js/Reports/proposition.js?vue&type=script&lang=js&external"
export * from "../js/Reports/proposition.js?vue&type=script&lang=js&external"
import style0 from "./ReportProposition.vue?vue&type=style&index=0&id=15b7b903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b7b903",
  null
  
)

export default component.exports